import React, { Component } from 'react';
import './ConfirmData.css';
import logoblue from '../../image/logoblue.png'
import { Link } from 'react-router-dom';
import Navbar from '../Components/Navbar/Navbar'
import { LinkAPI } from '../../API/API'
import HandleRes from '../Components/HandleRes/HandleRes';
import axios from 'axios'
import iconrightgreen from '../../image/iconrightgreen.svg'

class ConfirmEmail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            res_confirmemail:true,
            networkError: false,
            errordatamessage: false,
            errordatamessagetext: '',
            hasError: false,
        }
        this.ClientConfirmemail()
    }
    ClientConfirmemail = () => {
        const Token = this.props.match.params.Token
        axios.post(`${LinkAPI}/api/businessowner/confirmemail`, {}, {
            headers: {
                Authorization: `${Token}`,
                lang:"ar"
            }
        }).then(res => {
            console.log(res)

            localStorage.setItem("userTokentConfirmData", res.data.token)
            this.setState({
                res_confirmemail: false,
                networkError: false,
                errordatamessage: false,
                errordatamessagetext: '',
                hasError: false,            })
        }).catch(error => {
            console.log(error.response)
            if (!error.response) {
                this.setState({
                    networkError: true
                })
            } else if (error.response.status === 402) {
                window.location.replace("/SignUp");

            } else if (error.response.data.message) {
                this.setState({
                    errordatamessage: true,
                    errordatamessagetext: error.response.data.message
                })
            } else {
                this.setState({
                    hasError: true,
                })
            }
        })
    }



   
    render() {
        document.title ="Kayn | Confirm Email"; 
        document.getElementsByTagName("META")[1].content="Kayn Confirm Email";
        document.documentElement.lang = 'en';
        return (
            <div className="AppEN ConfirmData">
                <Navbar />
                <div className='container'>
                {(this.state.res_confirmemail?'':

                <div className="Sign  row">
                        <div className="logoform col-6 d-flex align-content-end flex-wrap">
                            <div className="col-12 text-center mt-auto p-2 bd-highlight"><Link to="/"><img className="logo" src={logoblue} alt="Kayn" /></Link>       </div>
                            <p className="fontsize2 text-center mb-5 col-12">Your package...your way</p>
                        </div>
                        <div className="col-md-6 form text-center p-lg-5 ">
                        <div className=" mx-auto  text-center textconfirm">
                        <img className="mt-2 warningimg" src={iconrightgreen} alt="warning" />
                            <p className="fontsize9 py-2">your email is confirmed</p>
                            <Link to="/ConfirmPhone">Verify your phone number</Link>
                        </div>
                       
                        </div>
                </div>)}
                </div>

                {(this.state.errordatamessage ? <HandleRes title={this.state.errordatamessagetext} stylecss="alert-danger" /> : '')}
                {(this.state.networkError ? <HandleRes title="You are currently offline." stylecss="alert-danger" /> : '')}
                {(this.state.hasError ? <HandleRes title="sorry there was a problem with your request" stylecss="alert-danger" /> : '')}

            </div>
        )
    }
}
export default ConfirmEmail;